export default __webpack_public_path__ + "static/media/c002-PPII-12.57595d00.svg";